import type { AuthUser, LoginInput, LoginResponse } from '@qb/shared';
import { http } from './http';

export const authApi = {
  login: (input: LoginInput) => http.post<LoginResponse>('/auth/login', input),
  logout: () => http.post<{ loggedOut: boolean }>('/auth/logout'),
  me: () => http.get<AuthUser>('/auth/me'),
};
